import { AsyncPipe, CommonModule, NgFor } from '@angular/common';
import { Component, forwardRef, OnInit } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Observable } from 'rxjs';
import { CountryService } from '../../../../services/country.service';

@Component({
  selector: 'app-country',
  standalone: true,
  imports: [NgFor, CommonModule, AsyncPipe],
  templateUrl: './country.component.html',
  styleUrls: ['./country.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CountryComponent),
      multi: true,
    },
  ],
})
export class CountryComponent implements OnInit, ControlValueAccessor {
  selectedCode: string = 'unknown';

  onChange = (selectedCode: any) => {};
  onTouched = () => {};
  touched = false;
  disabled = false;

  countryList: Observable<any> = new Observable();

  constructor(private countryService: CountryService) {}

  ngOnInit() {
    this.countryList = this.countryService.getCountries();
  }

  onIsoChange(event: any) {
    this.selectedCode = event.target.value;
    this.onChange(this.selectedCode != 'unknown' ? this.selectedCode : null);
  }

  writeValue(value: any) {
    this.selectedCode = value;
  }
  registerOnChange(onChange: any) {
    this.onChange = onChange;
  }
  registerOnTouched(onTouched: any) {
    this.onTouched = onTouched;
  }
  markAsTouched() {
    if (!this.touched) {
      this.onTouched();
      this.touched = true;
    }
  }
  setDisabledState(disabled: boolean) {
    this.disabled = disabled;
  }
}
